export class OwenerTransferModel {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  message: string;
  gender: string;

  constructor() {
    this.firstName = '';
    this.lastName = '';
    this.email = '';
    this.phone = '';
    this.message = '';
    this.gender = 'M';
  }
}
